import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { EmptyString, FormTypeAdd, InsertDateFormat } from "utils/Constant"
import moment from "moment";
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker";
import { addSpaceEvery4, money, removeNonNumeric } from "utils/helpers";
import { useCallApi } from "api/apiHooks";
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards";
import SaveButton from "components/Button/SaveButton";
import BackButton from "components/Button/BackButton";
import { useModal } from "utils/context/ModalContext";
import { useVariable } from "utils/context/VariableContext";

export default function PelunasanForm(){
    let navigate = useNavigate()

    const { locationId } = useVariable()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchTransactionCustomerCardList, fetchCustomerCardById, fetchInsertSettlement, fetchUpdateSettlement, fetchSettlementById } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let settlementId = queryString.get("settlementId")

    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [selectedCustomerCard, setSelectedCustomerCard] = useState(null)
    const [settlementDate, setSettlementDate] = useState(new Date())
    const [billingAmount, setBillingAmount] = useState('')
    const [mdr, setMdr] = useState('')
    const [customerPayment, setCustomerPayment] = useState('')
    const [settlementFee, setSettlementFee] = useState('')
    const [transactionAmount, setTransactionAmount] = useState('0')
    const [dueDate, setDueDate] = useState(new Date())
    const [virtualAccountNo, setVirtualAccountNo] = useState('')
    const [otherFee, setOtherFee] = useState('20,000')
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [paymentOptions, setPaymentOptions] = useState([
        { label: 'Bayar Titipan', value: '1' },
        { label: 'Bayar Penuh', value: '2' }
    ])
    const [payment, setPayment] = useState('2')
    const [remark, setRemark] = useState('')

    const customerCardOnInput = (e) => {
        fetchTransactionCustomerCardList(e, '', 0, 0, '1', 50, 0).then((res) => {
            if (!res) return

            if (res.data.listData.length > 0){
                let data = res.data.listData
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: addSpaceEvery4(data[i].cardNumber) + " (" + data[i].bankCode.trim() + ") - " + data[i].customerName, value: String(data[i].customerCardId) })
                }

                setCustomerCardOptions(tempArray)
            }
        })
    }
    const customerCardChange = (e) => {
        setSelectedCustomerCard(e)
        
        fetchCustomerCardById(e.value).then((res) => {
            if (!res) return
            let data = res.data

            setVirtualAccountNo(addSpaceEvery4(data.cardNumber))
            setMdr(data.mdr)
        })
    }

    const saveBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                if (formType === FormTypeAdd) {
                    const res = await fetchInsertSettlement(
                        moment(settlementDate).format(InsertDateFormat),
                        selectedCustomerCard.value,
                        0, 
                        billingAmount.replaceAll(',', ''), 
                        mdr, 
                        customerPayment.replaceAll(',', ''), 
                        settlementFee.replaceAll(',', ''), 
                        transactionAmount.replaceAll(',', ''), 
                        moment(dueDate).format(InsertDateFormat), 
                        payment, 
                        virtualAccountNo.replace(/\s+/g, ""),
                        otherFee.replaceAll(',', ''),
                        locationId,
                        remark
                    )

                    if (!res) return
                } else {
                    const res = await fetchUpdateSettlement(
                        settlementId,
                        moment(settlementDate).format(InsertDateFormat),
                        selectedCustomerCard.value,
                        0, 
                        billingAmount.replaceAll(',', ''), 
                        mdr, 
                        customerPayment.replaceAll(',', ''), 
                        settlementFee.replaceAll(',', ''), 
                        transactionAmount.replaceAll(',', ''), 
                        moment(dueDate).format(InsertDateFormat), 
                        payment, 
                        virtualAccountNo.replace(/\s+/g, ""),
                        otherFee.replaceAll(',', ''),
                        locationId,
                        remark
                    )

                    if (!res) return
                }
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: () => {
                        navigate('/pelunasan')
                    }
                })
            }
        }
        
    }

    useEffect(() => {
        const loadData = async () => {
            showLoading()

            try {
                const res = await fetchSettlementById(settlementId)

                if (!res) return 

                let data = res.data

                setSettlementDate(data.settlementDate)
                setSelectedCustomerCard({ label: data.customerName + ' (' + data.bankCode + ') ' + ' - ' + data.cardNumber, value: String(data.customerCardId) })
                setDueDate(data.dueDate)
                setVirtualAccountNo(addSpaceEvery4(data.virtualAccountNo))
                setMdr(data.mdr)
                setBillingAmount(money(data.billingAmount))
                setCustomerPayment(money(data.customerPayment))
                setOtherFee(money(data.otherFee))
                setTransactionAmount(data.transactionAmount)
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateBy(data.updateBy)
                setUpdateDate(data.updateDate)
                setPayment(data.payCustomerPayment)
                setRemark(data.remark)
            } finally {
                hideLoading()
            }
        }

        if(formType === FormTypeAdd){
            setStatus('Draft')
            
        } else {
            loadData()
            
        }
    }, [])

    useEffect(() => {
        if (mdr !== '' && billingAmount !== '' && customerPayment !== '') {
            let tagihan = parseFloat(billingAmount.replaceAll(',', ''))
            let titipan = parseFloat(customerPayment.replaceAll(',', ''))
            let biayaPL = otherFee === '' ? 0 : parseFloat(otherFee.replaceAll(',', ''))
            let sisaTagihan = tagihan - titipan + biayaPL
            let jumlahGesek = sisaTagihan / (100 - mdr) * 100

            let roundedUpThousand = Math.ceil(jumlahGesek / 1000) * 1000
            setTransactionAmount(money(roundedUpThousand))

            let fee = roundedUpThousand - sisaTagihan
            setSettlementFee(money(fee))
        } else {
            setSettlementFee('0')
        }
    }, [mdr, billingAmount, customerPayment, otherFee])


    return(
        <MainBodyCard>
            <PagesFormTitle 
                title={'Detail Pelunasan'} 
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />
            
            <div className="mt-5 flex flex-col gap-4">
                <FormCard title='Tanggal Pelunasan'>
                    <DatePicker className='h-10 bg-white w-full' value={settlementDate} onChange={setSettlementDate} />
                </FormCard>
                <FormCard title='Customer Card' width={'w-full sm:w-[560px]'}>
                    <Select options={customerCardOptions} value={selectedCustomerCard} onInputChange={customerCardOnInput} onChange={customerCardChange} placeholder='Pilih Customer Card' />
                </FormCard>
                <FormCard title='Tanggal Jatuh Tempo'>
                    <DatePicker className='h-10 bg-white w-full' value={dueDate} onChange={setDueDate} />
                </FormCard>
                <FormCard title='Rek Pembayaran'>
                    <input type="text" className="w-full px-3 py-2 border rounded-md" value={virtualAccountNo} onChange={(e) => setVirtualAccountNo(addSpaceEvery4(removeNonNumeric(e.target.value)))} placeholder="Rek Pembayaran / Virtual Account" maxLength={20} />
                </FormCard>
                <FormCard title='MDR' width={'w-32'}>
                    <div className="flex items-center gap-2">
                        <input type="text" className="w-full px-3 py-2 border rounded-md" value={mdr} onChange={(e) => setMdr(e.target.value)} placeholder="MDR" />
                        <span className="-translate-x-10">%</span>
                    </div>                    
                </FormCard>
                <FormCard title='Tagihan'>
                    <input type="text" className="w-full px-3 py-2 border rounded-md" value={billingAmount} onChange={(e) => setBillingAmount(money(e.target.value))} placeholder="Tagihan" />
                </FormCard>
                <FormCard title='Titipan'>
                    <input type="text" className="w-full px-3 py-2 border rounded-md" value={customerPayment} onChange={(e) => setCustomerPayment(money(e.target.value))} placeholder="Titipan" />
                </FormCard>
                <FormCard title='Biaya Pelunasan'>
                    <input type="text" className="w-full px-3 py-2 border rounded-md" value={otherFee} onChange={(e) => setOtherFee(money(e.target.value))} placeholder="Fee" />
                </FormCard>
                <FormCard title='Fee'>
                    <span>Rp { settlementFee }</span>
                </FormCard>
                <FormCard title='Gesek Lagi'>
                    <span>Rp { transactionAmount }</span>
                </FormCard>
                <FormCard title='Tipe Bayar'>
                    <div className="flex gap-2 p-1 rounded-full border justify-between bg-white">
                        { paymentOptions.map((data, i) => {
                            return (
                                <button
                                    className={`px-2 py-1 flex-1 rounded-full text-sm
                                        ${ payment === data.value ? 'bg-black text-white' : ''}
                                    `}
                                    key={i}
                                    onClick={() => { setPayment(data.value) }}
                                >
                                    { data.label }
                                </button>
                            )
                        })}
                    </div>
                </FormCard>
                <FormCard title='Remark'>
                    <input type="text" className="w-full px-3 py-2 border rounded-md" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder="Remark" />
                </FormCard>
            </div>

            <div className="flex gap-4 justify-end mt-4">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <BackButton onClick={() => navigate('/pelunasan')} />
            </div>
        </MainBodyCard>
    )
}
